import moment from "moment";
import dayjs from "dayjs";

export const PICKER_DATE_FORMAT = "DD-MM-YYYY";

function rangeFromTo(from, to) {
  const fromYmd = from.format("YYYY-MM-DD");
  const toYmd = to.format("YYYY-MM-DD");
  return {
    fromYmd,
    toYmd,
    fromMoment: from,
    toMoment: to,
    fromDayjs: dayjs(fromYmd),
    toDayjs: dayjs(toYmd),
    query: `fromDate=${fromYmd}&toDate=${toYmd}`,
  };
}

/** Khoảng mặc định: hôm nay */
export function defaultDayRange() {
  return rangeFromTo(moment().startOf("day"), moment().endOf("day"));
}

/** Khoảng mặc định: 7 ngày trước → hôm nay */
export function defaultWeekRange() {
  return rangeFromTo(
    moment().subtract(7, "days").startOf("day"),
    moment().endOf("day"),
  );
}

export function ymdFromPicker(value, endOfDay = false) {
  if (!value) return null;
  const d = dayjs.isDayjs(value) ? value : dayjs(value);
  if (!d.isValid()) return null;
  return (endOfDay ? d.endOf("day") : d.startOf("day")).format("YYYY-MM-DD");
}

export function pickerFromDisabled(dateToYmd) {
  return (current) => {
    if (!current) return false;
    if (!dateToYmd) return false;
    return current.isAfter(dayjs(dateToYmd), "day");
  };
}

export function pickerToDisabled(dateFromYmd) {
  return (current) => {
    if (!current) return false;
    if (!dateFromYmd) return false;
    return current.isBefore(dayjs(dateFromYmd), "day");
  };
}
